import MascotAvatar from "./MascotAvatar";
import { PENCIL_VIEWBOX, PENCIL_VIEW_W, PENCIL_VIEW_H } from "./PencilMascot";
import { VIEWBOX as PAPER_VIEWBOX, VIEW_W as PAPER_VIEW_W, VIEW_H as PAPER_VIEW_H } from "./PaperMascot";
import { FACES, PALETTES } from "./mascotMood";
import useMyMascot from "./useMyMascot";
import "./mascot.css";

// edge: local y where the card's top edge cuts the body (just under the mouth).
// top: local y aligned with the wrapper's top; anything above it pokes out.
const GEOMETRY = {
  pencil: { viewBox: PENCIL_VIEWBOX, viewW: PENCIL_VIEW_W, viewH: PENCIL_VIEW_H, edge: 112, top: 30, hands: [64, 136], hand: [14, 10], width: 104 },
  paper: { viewBox: PAPER_VIEWBOX, viewW: PAPER_VIEW_W, viewH: PAPER_VIEW_H, edge: 108, top: 24, hands: [58, 138], hand: [16, 11], width: 84 },
};

function Hands({ mode, pal, g }) {
  const [rx, ry] = g.hand;
  const [, right] = g.hands;
  if (mode === "slip") {
    return (
      <ellipse cx={right} cy={g.edge + 4} rx={rx - 1} ry={ry - 1} fill={pal.bot} stroke={pal.lip} strokeWidth="3" transform={`rotate(25 ${right} ${g.edge + 4})`} />
    );
  }
  const y = g.edge;
  return (
    <g className={`nm-hands nm-hands-${mode || "rest"}`}>
      {g.hands.map((x) => (
        <g key={x}>
          <ellipse cx={x} cy={y} rx={rx} ry={ry} fill={pal.bot} stroke={pal.lip} strokeWidth="3" />
          <path d={`M${x - 5} ${y - 4} V${y + 5} M${x + 1} ${y - 5} V${y + 5} M${x + 7} ${y - 4} V${y + 4}`} stroke={pal.lip} strokeWidth="2.2" strokeLinecap="round" />
        </g>
      ))}
    </g>
  );
}

/**
 * Wraps a card and has the player's chosen mascot peek over its top edge,
 * hands gripping the edge in front of the card. Mood comes from roundMood().
 */
export default function PeekingMascot({ mood = "focused", mascot: mascotProp, width: widthProp, right = 24, still = false, bodyClassName = "", children, className = "" }) {
  const mine = useMyMascot();
  const mascot = mascotProp || mine;
  const g = mascot.base === "pencil" ? GEOMETRY.pencil : GEOMETRY.paper;
  const width = widthProp || g.width;
  const face = FACES[mood] || FACES.focused;
  const pal = PALETTES[mascot.color] || PALETTES.red;
  const k = width / g.viewW;
  const pad = Math.round((g.edge - g.top) * k);
  const top = -Math.round((g.top + 34) * k);
  const height = (width * g.viewH) / g.viewW;
  const layer = { position: "absolute", right, top, width, height, pointerEvents: "none" };

  return (
    <div className={`relative ${className}`} style={{ paddingTop: pad }}>
      <div
        aria-hidden="true"
        className="nm-peek-body"
        style={{ ...layer, zIndex: 0, transform: face.sink ? `translateY(${Math.round(30 * k)}px)` : "none" }}
      >
        <div className={bodyClassName}>
          <MascotAvatar key={`${mascot.base}-${mascot.color}-${mascot.face}-${mood}`} mascot={mascot} mood={mood} variant="peek" size={width} shadow={false} still={still} className="nm-pop" />
        </div>
      </div>
      <div className="relative" style={{ zIndex: 1 }}>{children}</div>
      <svg aria-hidden="true" viewBox={g.viewBox} style={{ ...layer, zIndex: 2, overflow: "visible" }}>
        <Hands mode={still ? "rest" : face.hands} pal={pal} g={g} />
      </svg>
    </div>
  );
}
